const ITEMS = [
  "TIENDAS ONLINE",
  "DISEÑO GRÁFICO",
  "COMMUNITY MANAGER",
  "GOOGLE BUSINESS",
  "PÁGINAS WEB",
  "@SOCIFY_MARKETING",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-slate-800 bg-slate-950 py-5"
    >
      <div className="animate-marquee-slow flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono-sig text-sm uppercase tracking-[0.3em] text-slate-300"
              >
                <span className="px-6">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#00F0FF]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
